import { render, staticRenderFns } from "./MobileLoyalty.vue?vue&type=template&id=675c5166&scoped=true&"
import script from "./MobileLoyalty.vue?vue&type=script&lang=js&"
export * from "./MobileLoyalty.vue?vue&type=script&lang=js&"
import style0 from "./MobileLoyalty.vue?vue&type=style&index=0&id=675c5166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c5166",
  null
  
)

export default component.exports